import { useAccountStore } from '../components/Stores/accountStore';

/**
 * Central place to resolve the application's base currency.
 *
 * For now we default to USD if the account does not expose a base currency.
 * Once the account API includes a base currency field, this hook will
 * automatically start using it.
 */
export function useBaseCurrency(): string {
  const { account } = useAccountStore();

  // Prefer explicit base currency fields if/when they exist on the account
  const raw: unknown =
    (account as any)?.baseCurrency ||
    (account as any)?.base_currency ||
    null;

  const normalized =
    typeof raw === 'string' && raw.trim().length > 0
      ? raw.trim().toUpperCase()
      : null;

  // Single fallback location for our default base currency
  return normalized || 'USD';
}
